'use client';
var classes = {"root":"m-8b3717df","breadcrumb":"m-f678d540","separator":"m-3b8f2208"};

export { classes as default };
//# sourceMappingURL=Breadcrumbs.module.css.mjs.map
